module.exports = __webpack_public_path__ + "static/flags/ML-2a7e4d9fecece0b6c1003197902a5817.gif";